<template>
  <Modal
    ref="modal"
    title="Handgeschrieben optionen"
    class="modal-postcard-message-handwritten"
  >
    <template v-slot:content>
      <FlashMessage
        v-if="$parent.errors.length"
        type="error"
      >
        <p>{{ $parent.errors[0].message }}</p>
      </FlashMessage>

      <p
        v-if="$store.getters.getSelectedQty >= $store.getters.getOrderQtySize.xs.min"
        id="_ModulePostcardMessageOptions"
      >
        <slot>
          <FormInput
            class="u-dp-block"
            type="radio"
            value="1"
            @change="selectionData.option = 1"
            :checked="selectionData.option <= 1"
          >
            Gleicher Text für alle <b>{{ $store.getters.getSelectedQty }} Präsente</b>
          </FormInput>

          <FormInput
            v-if="$store.getters.getUserGroupId !== '14017'"
            class="u-dp-block"
            type="radio"
            value="2"
            @change="selectionData.option = 2"
            :checked="selectionData.option == 2"
          >
            Gleicher Text für alle <b>{{ $store.getters.getSelectedQty }} Präsente</b> mit persönlicher Anrede
            <br>
            <small>Beispiel: „Liebe Charlotte”</small>
          </FormInput>
        </slot>

        <FormInput
          class="u-dp-block"
          type="radio"
          value="3"
          @change="selectionData.option = 3"
          :checked="selectionData.option == 3"
        >
          Unterschiedliche Texte
        </FormInput>
      </p>
      <slot
        v-if="selectionData.option <= 1"
      >
        <p
          v-if="Object.keys(templates).length > 0"
          class="u-text-left u-mt-5"
        >
          <FormSelect
            @change="(v) => v == -1 ? validateMessage = '' : validateMessage = templates[v].default_text"
          >
            <option value="0" disabled selected>Textvorlage auswählen…</option>
            <option
              v-for="template in templates"
              :key="template.id"
              :value="template.id"
            >
              {{ template.name }}
            </option>
            <option value="-1">Keine</option>
          </FormSelect>
        </p>

        <p id="_ModulePostcardMessageWrite">
          <FormInput type="textarea-embeded">
            <textarea
              v-model="validateMessage"
              :maxlength="maxLength"
              rows="5"
              required="true"
              placeholder="Grußkartentext hier eingeben…"
              class="form-input__control"
            ></textarea>
          </FormInput>
        </p>

        <MessageCharCounter
          :mode="1"
          :text="validateMessage"
        />
      </slot>

      <Notice
        v-if="selectionData.option == 2"
      >
        <p>Sofern Sie eine persönliche Anrede (Beispiel: „Liebe Charlotte”) wünschen, benötigen wir für jeden Empfänger die korrekte Anrede mit gewünschtem Grußkartentext. Bitte beachten Sie, dass eine reine Namensliste nicht genügt, da viele Vornamen einem Geschlecht nicht eindeutig zugeordnet werden können (Beispiel: Liebe(r) Kim). Die Eingabe erfolgt über eine Excel-Vorlage, welche Sie nach der Bestellung per eMail erhalten.</p>
      </Notice>

      <Notice
        v-if="selectionData.option == 3"
      >
        <p>Die Zuordnung der gewünschten Grußkartentexte zu den jeweiligen Empfängern erfolgt mit Hilfe einer Excel-Vorlage, welche Sie nach der Bestellung per eMail erhalten.</p>
      </Notice>
    </template>

    <template v-slot:footer>
      <Button
        @click="submit()"
        appearance="primary"
        :disabled="selectionData.option === 1 && validateMessage.length < 1"
      >
        Auswahl bestätigen
      </Button>

      <Button
        @click="$refs.modal.close()"
        appearance="secondary"
      >
        Abbrechen
      </Button>
    </template>
  </Modal>
</template>

<script>
import { UiMixin } from '@/mixins/UiMixin';

import Modal from '@/components/Composer/Modal';
import Button from '@/components/Common/Button';
import FormInput from '@/components/Common/FormInput';
import FormSelect from '@/components/Common/FormSelect';
import Notice from '@/components/Composer/Notice';
import MessageCharCounter from '@/components/Composer/MessageCharCounter';
import FlashMessage from '@/components/Composer/FlashMessage';

export default {
  name: 'ModalPostcardMessageHandwritten',
  mixins: [UiMixin],
  props: {
    selectionData: {
      type: Object
    }
  },
  data () {
    return {
      message: '',
      templates: []
    };
  },
  components: {
    Modal,
    Button,
    FormInput,
    FormSelect,
    Notice,
    MessageCharCounter,
    FlashMessage
  },
  methods: {
    submit () {
      if ((this.selectionData.option === 1 || this.selectionData.option === 0) && this.validateMessage.length > 0) {
        this.selectionData.text = this.validateMessage;
        this.selectionData.mode = 1;
        this.selectionData.option = 1;
      }

      if (this.selectionData.option === 2 || this.selectionData.option === 3) {
        this.selectionData.mode = 1;
      }

      this.$refs.modal.close({
        submit: true
      });

      setTimeout(() => {
        this.scrollToComposerSection('_ModulePostcardAddons');
      }, 600);
    }
  },
  computed: {
    maxLength: {
      get () {
        return 480;
      }
    },
    validateMessage: {
      get () {
        return this.message;
      },
      set (value) {
        if (value.length > 480) {
          value = value.substr(0, 480);
        }

        this.message = value;
      }
    }
  },
  created () {
    this.message = this.selectionData.text;

    this.templates = this.$store.getters.getPostcardMessageTemplates;
  }
};
</script>

<style lang="scss" scoped>
/**
 * ModalPostcardMessageHandwritten
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Handwritten message options
 * @since 2022-09-06
**/

$component: 'modal-postcard-message-handwritten';

.#{$component} {
  //…

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-lg')) {
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($landing-page, 'viewport-xs')) {
  }
}
</style>
